import * as React from "react";
import { ProgressWithValue } from "./progress-with-value";

export function ProgressWithValueCustomLabelDemo() {
  return (
    <div className="flex flex-col space-y-4">
      <ProgressWithValue
        value={75}
        label={(val) => `${val}% complete`}
        position="end-outside"
      />

      <ProgressWithValue
        value={33}
        label={(val) => `${val}/100 points`}
        position="end-outside"
        valueClassName="font-semibold text-sm"
      />

      <ProgressWithValue
        value={50}
        label={(val) => (
          <span className="flex items-center gap-1">
            <span
              className={val && val > 30 ? "text-green-500" : "text-red-500"}
            >
              {val}%
            </span>
            {val && val > 30 ? "✓" : "✗"}
          </span>
        )}
        position="end-outside"
      />
    </div>
  );
}
